var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouletteWheelBorderTsl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x2014_\\xCE\\xD3\\xC8_x5F_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 715.43 715.42",
    style: {
      enableBackground: "new 0 0 715.43 715.42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FFE94D;}\n\t.st2{fill:#FFC3E0;}\n\t.st3{fill:#E72E5C;}\n\t.st4{fill:#FFDA3E;}\n\t.st5{fill:#1DB3DB;}\n\t.st6{fill:#E0D5B3;}\n\t.st7{fill:#871233;}\n\t.st8{fill:#FFEA6C;}\n\t.st9{fill:#EFE8CE;}\n\t.st10{fill:#FFED10;}\n\t.st11{fill:none;stroke:#E72E5C;stroke-width:8;stroke-miterlimit:10;}\n\t.st12{fill:#FFB8D3;}\n\t.st13{fill:none;stroke:#E0D5B3;stroke-width:6;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#E72E5C;stroke-width:5;stroke-miterlimit:10;}\n\t.st15{clip-path:url(#SVGID_00000029018371950358616290000013600809481460837534_);}\n\t.st16{fill:#A1E7FF;}\n\t.st17{fill:#131E60;}\n\t.st18{fill:#5B92F4;}\n\t.st19{fill:#D2E8FF;}\n\t.st20{fill:#0A1956;}\n\t.st21{fill:none;stroke:#5B92F4;stroke-width:8;stroke-miterlimit:10;}\n\t.st22{fill:none;stroke:#5B92F4;stroke-width:5;stroke-miterlimit:10;}\n\t.st23{clip-path:url(#SVGID_00000121256619685340824780000015220465184512271037_);}\n\t.st24{fill:#D9A4FF;}\n\t.st25{fill:#7622B2;}\n\t.st26{fill:#2D094C;}\n\t.st27{fill:none;stroke:#7622B2;stroke-width:8;stroke-miterlimit:10;}\n\t.st28{fill:none;stroke:#7622B2;stroke-width:5;stroke-miterlimit:10;}\n\t.st29{clip-path:url(#SVGID_00000085216834448728036890000017864507689514636169_);}\n\t.st30{fill:#57008C;}\n\t.st31{fill:#C63E74;}\n\t.st32{fill:#968D35;}\n\t.st33{fill:#C95D96;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 388.17,
    cy: 37.28,
    r: 15.33
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.26,569.16c-0.53-0.7-1.06-1.4-1.58-2.1C77.2,567.76,77.73,568.46,78.26,569.16z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.61,606.32c-0.22-0.22-0.45-0.45-0.67-0.68C110.16,605.87,110.39,606.1,110.61,606.32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.72,574.96c-0.21-0.27-0.42-0.54-0.63-0.81C82.3,574.42,82.51,574.7,82.72,574.96z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M605.47,110.47c0.16,0.16,0.33,0.33,0.5,0.5C605.8,110.8,605.64,110.64,605.47,110.47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400.19,10.62c1.35,0.16,2.7,0.32,4.03,0.5C402.87,10.95,401.53,10.78,400.19,10.62z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.57,82.94c0.18-0.14,0.37-0.29,0.55-0.43C141.94,82.65,141.76,82.79,141.57,82.94z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.4,78.47c0.73-0.55,1.46-1.1,2.19-1.63C148.85,77.37,148.12,77.92,147.4,78.47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.59,9.87c0.23,0.02,0.47,0.05,0.7,0.07C394.06,9.93,393.83,9.9,393.59,9.87z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.22,68.6c-1.3,0.88-2.6,1.77-3.89,2.67C158.64,70.36,159.93,69.47,161.22,68.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.33,71.27c-1.55,1.09-3.11,2.2-4.69,3.33C154.2,73.48,155.76,72.37,157.33,71.27z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.28,559.55c1.08,1.54,2.19,3.1,3.32,4.66C73.48,562.67,72.38,561.11,71.28,559.55z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.11,12.13c-1.79-0.28-3.59-0.54-5.42-0.8C407.5,11.58,409.3,11.85,411.11,12.13z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M541.38,59.9c-1.76-1.08-3.53-2.15-5.31-3.2C537.87,57.76,539.64,58.83,541.38,59.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M421.09,13.81c-1.57-0.29-3.14-0.56-4.72-0.83C417.96,13.25,419.54,13.52,421.09,13.81z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M421.11,13.81c-0.01,0-0.02,0-0.03,0C421.09,13.81,421.1,13.81,421.11,13.81z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M416.37,12.98c-1.73-0.29-3.48-0.58-5.26-0.85C412.87,12.39,414.62,12.69,416.37,12.98z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M551.42,66.34c-0.73-0.48-1.46-0.96-2.19-1.44C549.96,65.38,550.7,65.86,551.42,66.34z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M549.23,64.9c-2.39-1.56-4.83-3.13-7.36-4.7C544.34,61.73,546.79,63.31,549.23,64.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M551.42,66.34c0.4,0.26,0.79,0.54,1.19,0.81c0-0.01,0.01-0.01,0.01-0.02 C552.23,66.86,551.81,66.6,551.42,66.34z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M535.42,56.32c-1.88-1.11-3.77-2.19-5.67-3.26C531.68,54.14,533.57,55.22,535.42,56.32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M702.37,422.4c-0.2,1.11-0.42,2.21-0.64,3.31c0,0,0,0,0,0C701.96,424.63,702.17,423.52,702.37,422.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M653.57,546.35c-0.25,0.39-0.5,0.77-0.75,1.16C653.07,547.12,653.33,546.74,653.57,546.35L653.57,546.35z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M652.82,547.51c-0.92,1.44-1.87,2.86-2.81,4.29c0,0,0.01,0.01,0.01,0.01 C650.95,550.4,651.88,548.96,652.82,547.51z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.03,660.08c-1.87-1.11-3.71-2.21-5.51-3.32C176.35,657.88,178.19,658.99,180.03,660.08 C180.03,660.08,180.03,660.08,180.03,660.08z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M166.97,651.94c2.38,1.55,4.81,3.11,7.33,4.67C171.83,655.09,169.39,653.53,166.97,651.94z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M166.97,651.94c-0.8-0.52-1.59-1.04-2.37-1.56C165.39,650.91,166.18,651.43,166.97,651.94z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M163.39,649.59c0.39,0.26,0.81,0.53,1.2,0.79c-0.4-0.27-0.79-0.54-1.19-0.81 C163.4,649.58,163.4,649.59,163.39,649.59z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M191.24,666.43c0.49,0.26,0.98,0.52,1.47,0.78C192.22,666.94,191.73,666.69,191.24,666.43 C191.24,666.42,191.24,666.43,191.24,666.43z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M294.79,702.89c0.08,0.01,0.16,0.03,0.24,0.05C294.95,702.92,294.87,702.9,294.79,702.89z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M295.03,702.93c1.3,0.24,2.6,0.47,3.9,0.69C297.62,703.4,296.32,703.17,295.03,702.93z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M298.94,703.62c2.01,0.35,4.05,0.68,6.12,1C303.01,704.31,300.97,703.97,298.94,703.62z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M305.06,704.62c1.79,0.27,3.59,0.54,5.43,0.79C308.67,705.17,306.87,704.89,305.06,704.62z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M568.59,638.27c-0.72,0.54-1.43,1.08-2.14,1.6C567.17,639.34,567.88,638.81,568.59,638.27z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M558.65,645.47c1.55-1.08,3.11-2.19,4.68-3.33C561.79,643.27,560.22,644.37,558.65,645.47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M554.85,648.09c1.27-0.87,2.55-1.74,3.81-2.62C557.37,646.36,556.11,647.23,554.85,648.09z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M574.42,633.8c-0.17,0.13-0.33,0.26-0.5,0.39C574.09,634.05,574.25,633.93,574.42,633.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M605.76,605.97c-0.08,0.08-0.16,0.16-0.24,0.23C605.6,606.12,605.68,606.05,605.76,605.97z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.9,706.11c-1.39-0.17-2.79-0.33-4.16-0.52C313.13,705.77,314.52,705.94,315.9,706.11z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.46,706.85c-0.28-0.03-0.56-0.06-0.84-0.09C321.9,706.79,322.18,706.82,322.46,706.85z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M397.56,10.3c-1.1-0.13-2.18-0.23-3.27-0.35c1.97,0.2,3.93,0.44,5.89,0.67 C399.31,10.52,398.45,10.4,397.56,10.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M404.21,11.12c0.49,0.06,0.98,0.14,1.47,0.21C405.19,11.26,404.71,11.19,404.21,11.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M631.44,139.4c-8.62-10.77-17.24-20.21-25.48-28.43c9.72,9.74,18.87,20.05,27.39,30.88 C632.72,141.03,632.1,140.22,631.44,139.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M604.95,109.94C604.95,109.95,604.94,109.95,604.95,109.94c0.17,0.18,0.35,0.35,0.52,0.53 C605.3,110.3,605.12,110.12,604.95,109.94z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M142.13,82.51c1.74-1.37,3.5-2.71,5.27-4.04C145.65,79.78,143.89,81.13,142.13,82.51z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M139.78,84.34c-11.12,8.85-20.82,17.7-29.24,26.13c9.79-9.77,20.15-18.97,31.03-27.53 C140.97,83.41,140.38,83.86,139.78,84.34z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M149.58,76.83c1.01-0.75,2.04-1.49,3.06-2.23C151.63,75.33,150.61,76.07,149.58,76.83z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M318.45,706.42c1.07,0.12,2.12,0.23,3.17,0.34c-1.91-0.2-3.81-0.43-5.72-0.65 C316.76,706.21,317.59,706.33,318.45,706.42z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M357.93,708.63c-11.97,0-23.8-0.61-35.46-1.78C335.18,708.15,347.07,708.65,357.93,708.63z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M311.75,705.59c-0.42-0.06-0.84-0.12-1.26-0.18C310.91,705.47,311.32,705.53,311.75,705.59z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M76.68,567.06c-0.7-0.94-1.39-1.9-2.08-2.85C75.29,565.16,75.97,566.11,76.68,567.06z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M84.57,577.32c8.59,10.73,17.17,20.13,25.37,28.33c-9.65-9.68-18.74-19.93-27.22-30.68 C83.34,575.75,83.94,576.53,84.57,577.32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M82.09,574.15c-1.29-1.65-2.57-3.32-3.83-4.99C79.5,570.81,80.78,572.48,82.09,574.15z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M111.06,606.78C111.07,606.77,111.07,606.77,111.06,606.78c-0.14-0.16-0.3-0.3-0.45-0.45 C110.76,606.47,110.91,606.63,111.06,606.78z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "605.76,605.96 605.76,605.96 605.76,605.97  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M573.92,634.18c-1.76,1.38-3.54,2.74-5.33,4.09C570.36,636.95,572.13,635.58,573.92,634.18z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M576.24,632.38c11.14-8.86,20.86-17.74,29.29-26.18c-9.81,9.8-20.19,19.01-31.1,27.6 C575.03,633.32,575.63,632.87,576.24,632.38z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M566.45,639.87c-1.03,0.76-2.07,1.52-3.11,2.27C564.37,641.4,565.41,640.64,566.45,639.87z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M357.71,6.79C163.9,6.79,6.79,163.9,6.79,357.71S163.9,708.63,357.71,708.63s350.92-157.11,350.92-350.92 S551.52,6.79,357.71,6.79z M357.21,664.52c-169.08,0-306.15-137.07-306.15-306.15S188.13,52.22,357.21,52.22 s306.15,137.07,306.15,306.15S526.29,664.52,357.21,664.52z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M358.01,8.09c12.01,0,23.89,0.61,35.59,1.79C380.83,8.57,368.9,8.07,358.01,8.09z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M661.87,472.38c-0.05,0.09-0.1,0.18-0.15,0.27c0.11-0.11-0.25,0.89-0.44,1.57c0.18-0.32,0.08,2.5-0.05,1.05 c0.02,0.24,0.03,0.75,0.04,0.98c0-0.1,0-0.26-0.01-0.51c0,0.03,0.05,0.21,0.11,0.42c0.13,0.16,0.4,0.4,0.52,0.51 c0.01,0.01,0.03,0.02,0.05,0.03c0.32-1.3,0.62-2.6,0.92-3.91C662.52,472.68,662.2,472.55,661.87,472.38z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M357.71,715.42c-95.55,0-185.38-37.21-252.94-104.77C37.21,543.09,0,453.26,0,357.71 s37.21-185.38,104.77-252.94C172.34,37.21,262.17,0,357.71,0s185.38,37.21,252.94,104.77 c67.56,67.56,104.77,157.39,104.77,252.94s-37.21,185.38-104.77,252.94C543.09,678.22,453.26,715.42,357.71,715.42z  M357.71,13.58c-189.75,0-344.13,154.38-344.13,344.13s154.38,344.13,344.13,344.13s344.13-154.38,344.13-344.13 S547.47,13.58,357.71,13.58z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M357.21,671.32c-83.59,0-162.18-32.55-221.28-91.66c-59.11-59.11-91.66-137.69-91.66-221.28 c0-83.59,32.55-162.18,91.66-221.28c59.11-59.11,137.69-91.66,221.28-91.66c83.59,0,162.18,32.55,221.28,91.66 c59.11,59.11,91.66,137.69,91.66,221.28c0,83.59-32.55,162.18-91.66,221.28C519.39,638.76,440.8,671.32,357.21,671.32z  M357.21,59.01c-165.07,0-299.36,134.29-299.36,299.36s134.29,299.36,299.36,299.36s299.36-134.29,299.36-299.36 S522.28,59.01,357.21,59.01z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 587.1,
    cy: 123.14,
    r: 9.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 103.4165 356.1988)",
    className: "st10",
    cx: 481.68,
    cy: 53.26,
    rx: 9.17,
    ry: 9.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 656.04,
    cy: 224.43,
    r: 9.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 683.81,
    cy: 350.7,
    r: 9.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 662.7,
    cy: 473.52,
    r: 9.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2298 -0.9732 0.9732 0.2298 -109.3548 1029.9326)",
    className: "st10",
    cx: 596.01,
    cy: 584.05,
    rx: 9.17,
    ry: 9.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 484.14,
    cy: 660.17,
    r: 9.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 356.03,
    cy: 686.9,
    r: 9.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 233.44,
    cy: 660.17,
    r: 9.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 128.38,
    cy: 593.23,
    r: 9.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 54.03,
    cy: 484.22,
    r: 9.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 28.47,
    cy: 355.02,
    r: 9.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.229 -0.9734 0.9734 0.229 -185.9377 230.6792)",
    className: "st10",
    cx: 52.65,
    cy: 232.71,
    rx: 9.17,
    ry: 9.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 126.23,
    cy: 123.45,
    r: 9.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2298 -0.9732 0.9732 0.2298 128.4995 268.8957)",
    className: "st10",
    cx: 234.13,
    cy: 53.26,
    rx: 9.17,
    ry: 9.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 365.21,
    cy: 28.08,
    r: 9.17
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouletteWheelBorderTsl);
export default __webpack_public_path__ + "static/media/roulette-wheel-border-tsl.54396fc97c8fd16938cf8ed8d4867689.svg";
export { ForwardRef as ReactComponent };